import  {React, useState} from "react";
import "./CareerFormBanner.css";
import { Col, Container, Row } from "react-bootstrap";
import AOS from 'aos';
import 'aos/dist/aos.css';




const CareerFormBanner = (props) => {
    

    return (
        <>
            {/* <div style={{ paddingTop: props.height }} >
                <img src={CareerBannerImg} className="img-fluid"></img>
            </div> */}
            <div className="career-form-banner-sc" style={{ paddingTop: props.heightPass }} >
                <Container>
                    <Row>
                        <Col>
                            <div className="banner-name">
                                <h3>Careers</h3>
                            </div>
                            <h2 className="banner-description">Thrive in a dynamic environment with <br/> growth opportunities, innovation, and <br/> collaborative teamwork.</h2>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default CareerFormBanner;